import { GridSize, GridSizeSmall } from '@drone-js/core/dist/types/components/Grid/GridItem';

interface GridSizeObject {
    xl: GridSize;
    lg: GridSize;
    md: GridSize;
    sm: GridSizeSmall;
}

export enum GridSizeEnum {
    Two = 2,
    Three = 3,
    Four = 4,
    Six = 6,
    Nine = 9,
    Ten = 10,
    Twelve = 12,
}
export const CardGridSize: GridSizeObject = {
    xl: GridSizeEnum.Three,
    lg: GridSizeEnum.Four,
    md: GridSizeEnum.Six,
    sm: GridSizeEnum.Twelve,
};
